export const categoryInfo: Record<string, { name: string; description: string; icon: string }> = {
  '全部': {
    name: '全部漫画',
    description: '妖精漫画为您提供海量韩国漫画资源，涵盖热血、恋爱、奇幻、悬疑等多种题材，下拉式阅读体验流畅自然，如同一个线上漫画博物馆。',
    icon: 'ri-global-line',
  },
  '恋爱': {
    name: '恋爱漫画',
    description: '甜蜜浪漫的韩国恋爱漫画专区，从校园纯爱到职场恋情，从穿越宫廷到现代爱情，每一部都让人心动不已。下拉式韩漫大全，畅享免费阅读。',
    icon: 'ri-heart-line',
  },
  '热血': {
    name: '热血漫画',
    description: '燃爆的韩国热血漫画合集，战斗、成长、冒险、武侠——每一部都能点燃你的热血之魂。妖精漫画为您精心挑选最精彩的热血韩漫。',
    icon: 'ri-fire-line',
  },
  '奇幻': {
    name: '奇幻漫画',
    description: '打开异世界大门的韩国奇幻漫画专区，魔法、异界、重生、冒险——带你进入一个个令人惊叹的幻想世界。下拉式阅读，畅享奇幻之旅。',
    icon: 'ri-magic-line',
  },
  '悬疑': {
    name: '悬疑漫画',
    description: '扣人心弦的韩国悬疑漫画精选，推理、惊悚、超自然、校园怪谈——每一部都让人欲罢不能。妖精漫画带您探索未知的悬疑世界。',
    icon: 'ri-search-eye-line',
  },
};